module.exports = __webpack_public_path__ + "img/bestdoclogo.25cdf29.svg";